// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3VH4e","newExpiryDate":"styles_newExpiryDate__3G2B0","footer":"styles_footer__3CGYu"};